"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapCanBeSubscribed = void 0;
var _internal = require("../utils/internal");
var _constants = require("./constants");
const mapCanBeSubscribed = labels => labels?.find((0, _internal.findLabelByKey)(_constants.LABEL_CAN_BE_SUBSCRIBED)) !== undefined;
exports.mapCanBeSubscribed = mapCanBeSubscribed;
//# sourceMappingURL=mapCanBeSubscribed.js.map